<template>
	<div class="job-fuzzy-matrix">
		<Loading v-if="loading"/>
		<template v-else>
			<Category
				v-for="category in matrix.categories"
				:key="category.id"
				:category="category"
				:filter-values="filterValues"
				@filterValue="$emit('filterValue', $event)"
			/>
			<div v-if="filterValues && filterValues.length > 0">
				<div class="d-flex mb-2">
					<div class="font-weight-bold font-size-big color-red">Aktive Filter</div>
					<div class="ml-3">
						<a href="#" @click.prevent="$emit('resetFilterValues')">
							<Icon icon="bin" /> <span class="font-size-small">alle Filter löschen</span>
						</a>
					</div>
				</div>
				<div
					v-for="(filterValue, i) in filterValues"
					:key="filterValue.id"
					:class="['p-2', { 'bg-color-light-gray': i % 2 === 0 }]"
				>
					<b-row>
						<b-col md="3">
							{{ rowByValueTypeLabels[filterValue.type] }}
						</b-col>
						<b-col md="9">
							<a href="#" @click.prevent="$emit('filterValue', filterValue)">
								<Icon icon="bin" class="mr-1" />
							</a>
							{{ filterValue.label }}
						</b-col>
					</b-row>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import Loading from "@/vue/common/Loading";
import FuzzyMatrix from "@/api/job/FuzzyMatrix";
import Category from "./Category"
import Icon from "@/vue/icon/Icon"
import _ from "lodash";

export default {

	components: {
		Loading,
		Icon,
		Category,
	},

	props: {
		jobId: {
			type: String,
			required: true,
		},
		filterValues: {
			type: Array,
			required: true,
		},
	},

	mounted ()
	{
		this.load();
	},

	data ()
	{
		return {
			loading: true,
			matrix: null,
		};
	},

	computed: {
		rowByValueTypeLabels ()
		{
			let labels = [];

			_.forEach(this.matrix.categories, category =>
			{
				_.forEach(category.rows, row =>
				{
					_.forEach(row.values, value =>
					{
						labels[value.type] = row.label;
					});
				});
			});

			return labels;
		},
	},

	methods: {
		async load ()
		{
			this.$emit('loadStart');

			this.loading = true;

			const response = await new FuzzyMatrix()
				.setJob(this.jobId)
				.call();

			this.matrix = response.data.matrix;

			this.loading = false;

			this.$emit('loadEnd');
		}
	},
}
</script>
